import React from 'react';
import SuperAdmin from '../../components/superadmin/SuperAdminContainer';

export default function SuperAdminPage() {
  return (
    <SuperAdmin />
  );
}
